import { type InferRouteNames } from "@/types/infer-route-names"

export const MeterPowerAnalysisRouteNames = {
    FromDashboard: "fromDashboard",
    Landing: "landing",
    Error: "error",
    Overload: "overload",
    Adapted: "adapted",
    Results: "results",
} as const

export type MeterPowerAnalysisRouteNames = InferRouteNames<typeof MeterPowerAnalysisRouteNames>
